import script from "./InfoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoSection.vue?vue&type=script&setup=true&lang=js"

import "./InfoSection.vue?vue&type=style&index=0&id=20828b98&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20828b98"]])

export default __exports__